import React, { useState } from 'react';
import './OurServices.css';

import videoProductionImage from '../../Assets/services-images/portrait-fitness-influencer.png';
import documentriesImage1 from '../../Assets/services-images/Documentery.png';
import creativeInterviewImage from '../../Assets/services-images/high-angle-man-with-laptop-podcast.png';
import commercialImage from '../../Assets/services-images/man-woman-looking-clipboard.png';
import event1 from '../../Assets/services-images/Event.png';
import shortFilmImage1 from '../../Assets/services-images/Short Film.png';
import markeetingImage from '../../Assets/services-images/tech-vlogger.png';

import PrimeryButton from '../../ControlledComponents/PrimeryButton/PrimeryButton';
import { useNavigate } from 'react-router-dom';
import Button4 from '../../GlobalComponents/button3';
import { TbLayoutDashboardFilled } from "react-icons/tb";
import { useTranslation } from 'react-i18next';

const OurServices = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Get the translated array of items
  const translatedItems = t('subservices.items', { returnObjects: true });

  // Match each item with its corresponding image
  const images = [
    videoProductionImage,
    documentriesImage1,
    creativeInterviewImage,
    commercialImage,
    event1,
    shortFilmImage1,
    markeetingImage
  ];

  // Combine translated data with images
  const servicesData = translatedItems.map((item, index) => ({
    name: item.question,
    para: item.para,
    gridClass: item.gridClass,
    img: images[index]
  }));

  const [currentIndex, setCurrentIndex] = useState(null);
  const handleMouseOver = (index) => setCurrentIndex(index);
  const handleMouseLeave = () => setCurrentIndex(null);

  return (
    <div className='our-services-main-section'>
      <h3>{t("services.title")}</h3>
      <p className='section_slogan'>{t("services.description")}</p>

      <div className='services-show-case-main-container'>
        {servicesData.map((item, index) => (
          <div
            key={index}
            className={`grid-col ${item.gridClass}`}
            onMouseEnter={() => handleMouseOver(index)}
            onMouseLeave={handleMouseLeave}
          >
            <div className={`flesh-container ${currentIndex === index ? 'slide-flash' : ''}`}></div>
            <img src={item.img} alt={item.name} />
            <div className={`col-overlay ${currentIndex === index ? 'show-overlay' : ''}`}>
              <h3>{item.name}</h3>
              <div className={`col-inner-overlay ${currentIndex === index ? 'show-inner-overlay' : ''}`}>
                <div className={`inner-overlay-containt ${currentIndex === index ? 'inner-overlay-containt-effect' : ''}`}>
                  <h3>{item.name}</h3>
                  <p>{item.para}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className='services_btn'>
        <Button4
          text_1={t("services.seeall")}
          text_2={t("services.seeall")}
          iconComponent={TbLayoutDashboardFilled}
          width={"220px"}
          navigateClick={() => {
            navigate("/services");
          }}
        />
      </div>
    </div>
  );
};

export default OurServices;
